module.exports = __webpack_public_path__ + "img/Rectangle.5812afc9.svg";